import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { Http, RequestOptions, Headers } from "@angular/http";
import { Storage } from "@ionic/storage";
import { ConfigurationService } from "ionic-configuration-service";
import { AuthService } from "../auth-service";

/*
  Generated class for the WaybillOrderServiceProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class SummaryServiceProvider {
  public data: any;

  public token: any;

  constructor(
    private configurationService: ConfigurationService,
    public http: Http,
    private auth: AuthService,
    private storage: Storage
  ) { }

  load_dashboard_deta() {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        this.http
          .get(
            this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/backoffice/summary",
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  post_data(end_point, request_body) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        this.http
          .post(
            this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/" +
            end_point,
            request_body,
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  update_data(end_point, request_body) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        this.http
          .put(
            this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/" +
            end_point,
            request_body,
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  load_tickets_data(query_url) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });

        //let fake_response = {"code":1001,"msg":"Success","data":{"content":[{"ticket_id":"1","title":"some title","description":"  lerem ipsum  lerem ipsum lerem ipsum lerem ipsum lerem ipsum lerem ipsum lerem ipsum lerem ipsum","deadline_date":"2018-10-02 12PM","update_date":"2018-10-02 12PM","assigned_person":{"name":"hussain","picture":"https://urltopicture.jpg"},"status":"processing","department":"customer_support","priority":"hign","tags":["Merchants","Shipments"],"comments":[{"createTime":"2018-10-08T09:47:26Z","text":"She said she will try to collect 6 PM tonight","userEntity":{"id":"1201509100623111619","name":"Wajid Khan"}},{"createTime":"2018-10-08T09:47:26Z","text":"She said she will try to collect 6 PM tonight","userEntity":{"id":"1201509100623111619","name":"Wajid Khan"}},{"createTime":"2018-10-08T09:47:26Z","text":"She said she will try to collect 6 PM tonight","userEntity":{"id":"1201509100623111619","name":"Wajid Khan"}}]},{"ticket_id":"2","title":"some title","description":"  lerem ipsum  lerem ipsum lerem ipsum lerem ipsum lerem ipsum lerem ipsum lerem ipsum lerem ipsum","deadline_date":"2018-10-02 12PM","update_date":"2018-10-02 12PM","assigned_person":{"name":"hussain","picture":"https://urltopicture.jpg"},"status":"processing","department":"customer_support","priority":"hign","tags":["Merchants","Shipments"],"comments":[{"createTime":"2018-10-08T09:47:26Z","text":"She said she will try to collect 6 PM tonight","userEntity":{"id":"1201509100623111619","name":"Wajid Khan"}},{"createTime":"2018-10-08T09:47:26Z","text":"She said she will try to collect 6 PM tonight","userEntity":{"id":"1201509100623111619","name":"Wajid Khan"}},{"createTime":"2018-10-08T09:47:26Z","text":"She said she will try to collect 6 PM tonight","userEntity":{"id":"1201509100623111619","name":"Wajid Khan"}}]},{"ticket_id":"3","title":"some title","description":"  lerem ipsum  lerem ipsum lerem ipsum lerem ipsum lerem ipsum lerem ipsum lerem ipsum lerem ipsum","deadline_date":"2018-10-02 12PM","update_date":"2018-10-02 12PM","assigned_person":{"name":"hussain","picture":"https://urltopicture.jpg"},"status":"processing","department":"customer_support","priority":"hign","tags":["Merchants","Shipments"],"comments":[{"createTime":"2018-10-08T09:47:26Z","text":"She said she will try to collect 6 PM tonight","userEntity":{"id":"1201509100623111619","name":"Wajid Khan"}},{"createTime":"2018-10-08T09:47:26Z","text":"She said she will try to collect 6 PM tonight","userEntity":{"id":"1201509100623111619","name":"Wajid Khan"}},{"createTime":"2018-10-08T09:47:26Z","text":"She said she will try to collect 6 PM tonight","userEntity":{"id":"1201509100623111619","name":"Wajid Khan"}}]}],"totalElements":3,"totalPages":1,"last":false,"numberOfElements":3,"size":5,"number":0,"sort":[{"direction":"DESC","property":"orderNo","ignoreCase":false,"nullHandling":"NATIVE","descending":true,"ascending":false}],"first":true},"is_end":0};

        //resolve(fake_response);

        this.http
          .get(
            this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/ticket?" +
            query_url,
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  load_cp_data_details(id) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          "api/v0.2/techsupport/collectionpoints/" + id;
        this.http
          .get(url, options)
          .map(res => res.json())
          .subscribe(
            data => {
              resolve(data);
            },
            error => {
              console.log(error);
              resolve(error);
            }
          );
      });
    });
  }

  load_cp_data(pram) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        /// HERE WE WILL CALL FUZZY SEARCH TO GET ANY  INFORMATION QUICKLY

        let userInfo = JSON.parse(localStorage.getItem("userInfoData"));
        // let userInfo: any = localStorage.getItem("userInfoData");

        let qs = "";
        if (userInfo) {
          if (userInfo.currency) {
            qs += `&currency=${userInfo.currency}`;
          }
        }
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          "api/v0.2/techsupport/collectionpoints?" +
          pram +
          qs;
        this.http
          .get(url, options)
          .map(res => res.json())
          .subscribe(
            data => {
              resolve(data);
            },
            error => {
              console.log(error);
              resolve(error);
            }
          );
      });
    });
  }

  load_dashboard_actions_history_data(query_url) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });

        this.http
          .get(
            this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/backoffice/historyStats?" +
            query_url,
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            resolve(data);
          });
      });
    });
  }

  load_dashboard_active_parcels_data(query_url) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });

        this.http
          .get(
            this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/backoffice/activeStats?" +
            query_url,
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            resolve(data);
          });
      });
    });
  }

  load_area_summary() {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        this.http
          .get(
            this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/backoffice/areasSummary",
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  load_driver_summary() {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        this.http
          .get(
            this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/backoffice/driversSummary",
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  load_ecommerce_summary() {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          "api/v0.2/backoffice/clients";
        this.http
          .get(url, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  getRequestInfo(endpoint) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") + endpoint;
        this.http
          .get(url, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  getProfileInfo(endpoint) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") + endpoint;
        this.http
          .get(url, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  getMerchantsInfo(endpoint) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") + endpoint;
        this.http
          .get(url, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  getMerchantsAccountsInfo(qs?) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/techsupport/users?${qs}`;
        this.http
          .get(url, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  addMerchantUser(payload) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/techsupport/users`;
        this.http
          .post(url, payload, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  createManualDhlShipment(payload) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/backoffice/shipment/query/dhl/create`;
        this.http
          .post(url, payload, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  updateMerchantUser(id, payload) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/techsupport/users/${id}`;
        this.http
          .patch(url, payload, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  deleteWorkingTiming(data) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers, body: data });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/techsupport/collectionpoints/workhours`;
        this.http
          .delete(url, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  patchCPTimings(id, data) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/techsupport/collectionpoints/${id}`;
        this.http
          .patch(url, data, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  patchCPInfo(id, data) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/techsupport/collectionpoints/${id}`;
        this.http
          .patch(url, data, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  putTransferCP(orderNo, data) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/backoffice/shipment/${orderNo}`;
        this.http
          .put(url, data, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  cancelShipment(data) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers, body: data });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/backoffice/shipments`;
        this.http
          .delete(url, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  createHoldRto(data) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/backoffice/rtoholding`;
        this.http
          .post(url, data, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  updateHoldRto(id, data) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/backoffice/rtoholding/${id}`;
        this.http
          .put(url, data, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  getApiUrl(d) {
    return (
      this.configurationService.getValue<string>("API_ENDPOINT") +
      "api/v0.2/" +
      d
    );
  }

  postUploadProfile(end_point, request_body) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        //headers.append('Content-Type', 'application/json');
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        this.http
          .post(
            this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/" +
            end_point,
            request_body,
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  postAddSites(end_point, request_body) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        //headers.append('Content-Type', 'application/json');
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        this.http
          .post(
            this.configurationService.getValue<string>("API_ENDPOINT") +
            "api/v0.2/" +
            end_point,
            request_body,
            options
          )
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  getRtoHoldList(endpoint) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") + endpoint;
        this.http
          .get(url, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }

  deleteRtoHolding(data) {
    return new Promise(resolve => {
      this.storage.get("jwt_token").then(value => {
        let headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", "Bearer " + value);
        let options = new RequestOptions({ headers: headers, body: data });
        let url =
          this.configurationService.getValue<string>("API_ENDPOINT") +
          `/api/v0.2/backoffice/rtoholding/${data}`;
        this.http
          .delete(url, options)
          .map(res => res.json())
          .subscribe(data => {
            if (data.code == 1001) {
              resolve(data);
            }
          });
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/wh/summary-service.ts